import React from 'react';
import invariant from 'invariant';
import { isUndefined } from '@jupiter-app/utils';
import { Plugin, AppContext } from './typings';

export function pluginSpecialHookHelper({
  plugins = [],
}: {
  plugins: Plugin[];
}) {
  return {
    composeOnCreateApp(
      AppComponent: React.ComponentType<any>,
      config: any,
    ): React.ComponentType<any> {
      return plugins.reduce((_AppComponent, plugin) => {
        const specialHook = plugin.__SPECIALHOOK__;
        return specialHook && specialHook.onCreateApp
          ? specialHook.onCreateApp(_AppComponent, config)
          : _AppComponent;
      }, AppComponent);
    },
  };
}
export default function pluginHelper(
  { plugins }: { plugins: Plugin[] },
  context: AppContext,
) {
  const bindPlugins = plugins.map((plugin: any) => {
    const pluginResult = plugin(context);

    if (process.env.NODE_ENV !== 'production') {
      invariant(
        !isUndefined(pluginResult.name),
        `${plugin.toString()} \n plugin must set name`,
      );
    }

    // 记录已加载的插件
    context._pluginsMap[pluginResult.name] = pluginResult;

    return pluginResult;
  });
  return {
    composeProvider(element: React.ReactElement, config: any) {
      return bindPlugins.reduce((ele: React.ReactElement, plugin: any) => {
        return plugin.Provider ? plugin.Provider(ele, config) : ele;
      }, element);
    },
  };
}
